// get our Application namespace declared
try {
    var GP = new Marionette.Application();
} catch (e) {
    if (typeof Sentry != 'undefined') {
        var sentry_error_data = {
            tags: {
                gp_js: 'error creating main GP object'
            },
            extra: {
                jquery:     (typeof jQuery),
                backbone:   (typeof Backbone),
                marionette: (typeof Marionette)
            }
        };
        Sentry.captureException(e, sentry_error_data);
    }
}

window.GP = GP;

// setup container for each pages js (for pages that are not part of a module yet)
GP.page_js = {};

// extend the application prototype for reuse of common resources and shared data
Marionette.Application.prototype.shared = {
    models:{},
    collections:{},
    views:{},
    sdata:{},
    api:{},
    vent:GP.vent,
    Backbone:Backbone,
    Marionette:Marionette,
    $:jQuery,
    _:_
};

// declare our custom mod with automated boiler
Marionette.Application.prototype.GPModule = Marionette.Module.extend({
    initialize:function(moduleName, app, opts) {
        // map our shortcuts
        // this.el = '#'+this.moduleName;
        this.vent = this.app.vent;

        this.addInitializer(function(){
            // we'll wait on this because the DOM might
            // not be ready yet, but as soon as we fire
            // up this will be the first thing we do.
            // this.$el = this.$(this.el);
        });
    }
});

// declare our shortcut for automation
Marionette.Application.prototype.GPMod = function(name /*[opts], module_definition*/ ) {
    var defined = false, opts = false;
    var mod_obj = {
        moduleClass: this.GPModule
    };

    // NOTE: opts is an optional parameter, here we'll test
    // the total num of arguments and figure out our mappings
    // for opts and definitions before passing them into
    // Marionette for module declaration
    if (arguments.length <= 2) {
        mod_obj.define = arguments[1];
    } else {
        mod_obj.define = arguments[2];
        // map options passed to local mod_obj for access via self.options.VAR
        opts = arguments[1];
        if (typeof opts == 'object') {
            for (var prop in opts) {
                if (opts.hasOwnProperty(prop)) {
                    mod_obj[prop] = opts[prop];
                }
            }
        }
    }

    this.module(name,mod_obj);
};

// things we'll map our Application prototype with
var share_on = [
    'Application',
    'Module'
];

// map our proto to our children that will need it
for (var i=0; i < share_on.length; i++) {
    var shared = Marionette.Application.prototype.shared;
    var child  = Marionette[share_on[i]];
    for (var proto in shared) {
        if (shared.hasOwnProperty(proto)) {
            child.prototype[proto] = shared[proto];
        }
    }
}

GP.addInitializer(function(init) {
    try {
        // sdata = shared data = globally accessable object
        // so we can access any data we need from anywhere
        this.sdata.is_mobile        = _is_mobile;
        this.sdata.is_tablet        = _is_tablet;
        this.sdata.my_user          = init.my_user;
        this.sdata.MessagingUsers   = new GP.collections.Users();
        this.sdata.MessagingThreads = new GP.collections.Threads();
        this.sdata.Activities       = new GP.collections.Activities();
        this.sdata.ActivityUsers    = new GP.collections.ActivityUsers();

        // ensure thread_style is set.  2 = docked (default/free), 1 = maximized
        this.sdata.thread_style = 2;
        if (typeof(init.my_user.msg_prefs.thread_style) != 'undefined') {
            var thread_style_int = parseInt(init.my_user.msg_prefs.thread_style, 10);

            this.sdata.thread_style = thread_style_int;
            this.sdata.my_user.msg_prefs.thread_style = thread_style_int;
        }
    } catch(e) {
        if (typeof Sentry != 'undefined') {
            Sentry.captureException(e, {
                extra: {
                    init_obj: init,
                    location: 'GP.addInitializer'
                }
            });
        }
    }
});


// set jQuery ajaxError handler to our custom handler for manipulation before sending to Sentry
$(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
    // only send errors for responses with code 200 (i.e. valid responses, not timeouts, network errors, etc...)
    if (jqXHR && jqXHR.status && parseInt(jqXHR.status, 10) === 200) {
        if (typeof Sentry != 'undefined') {

            // only send to Sentry if we have some sort of responseText
            if (jqXHR.responseText) {
                var response_text = jqXHR.responseText.substring(0,250),
                    sentry_extra  = {
                        extra: {
                            ajax_url:    ajaxSettings.url,
                            method:      ajaxSettings.type,
                            status_text: jqXHR.statusText,
                            form_data:   (ajaxSettings.data ? ajaxSettings.data : '[no_form_data]'), // any form data sent along
                            response:    response_text // first 250 characters of the response
                        }
                    };

                // use the thrownError obj if it's an error obj or make one ourselves
                if (thrownError instanceof Error || (thrownError && thrownError.stack && thrownError.message)) {
                    Sentry.captureException(thrownError, sentry_extra);
                } else {
                    Sentry.captureException(new Error((jqXHR.statusText || 'no jqXHR.statusText')), sentry_extra);
                }
            }
        }
    }
});


// _gp_start was previously the anonymous function passed to the jquery method (shorthand for DOM ready event)
// putting in a named function here, so we can either wrap this function for error reporting purposes
// or just use it if that's not available/disabled etc...
var _gp_start = function() {
    // trigger init_js event for initial page load
    GP.on("start", function(init) {
        if (typeof init != 'undefined' && init) {

            if (init.my_user) {
                if (init.my_user.module && init.my_user.page) {
                    var module_page = init.my_user.module+':'+init.my_user.page;
                    var page_js_obj = GP.page_js[module_page] = {};

                    this.vent.trigger('init_js:' + module_page, page_js_obj);
                }
            }

            // update profile's data for current duid on page load if needed
            if (init.profile_duid) {
               vent.trigger('Profile:update_duid', {duid: init.profile_duid});
            }

            if (init.show_modal.url) {
                init.show_modal.auto_trigger = true;
                this.vent.trigger('Modal:open', init.show_modal);
            }
        }

        if (typeof _profile_only != 'undefined' && _profile_only) {
            MoshPit.add_state('profile_only');
        }
    });


    // start our marionette application (GP)
    GP.start((_marionette_init_obj || {}));


    _flash_enabled = false;
    if (typeof swfobject != 'undefined') {
        _flash_enabled = (swfobject.hasFlashPlayerVersion("9.0.0") ? true : false);
    }
    GP.vent.trigger('Header:handle_no_flash', _flash_enabled, _is_mobile);
};


// jQuery DOM ready handler which starts the marionette app
//
// pass either a wrapped version of _gp_start so we can capture all exceptions and send to sentry,
// or just the _gp_start function to jQuery to be executed when the DOM is ready
// $( ((typeof Sentry != 'undefined') ? Sentry.wrap(_gp_start) : _gp_start) ); // Sentry.wrap() not working right
$(function() {
    try {
        _gp_start();
    } catch (e) {
        Sentry.captureException(e);
    }
});



